import { render, staticRenderFns } from "./TermsTopPanel.vue?vue&type=template&id=4b4aec36&scoped=true"
import script from "./TermsTopPanel.vue?vue&type=script&lang=js"
export * from "./TermsTopPanel.vue?vue&type=script&lang=js"
import style0 from "./TermsTopPanel.vue?vue&type=style&index=0&id=4b4aec36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4aec36",
  null
  
)

export default component.exports